import type { ServerResponseSchema } from 'app'

export const serverResponse = <TData, TType extends object = object>(
  props: Partial<ServerResponseSchema<TData>> = {},
  overrideProps: Partial<ServerResponseSchema<TData>> = {},
) =>
  ({
    data: [] as unknown as TData,
    ...props,
    loaded: false,
    loading: false,
    ...overrideProps,
  }) as ServerResponseSchema<TData> & TType

export default serverResponse
